<template>
  <v-row no-gutters dense class="pa-2 card-line">
    <v-col cols="12" md="8" xs="8" sm="8" class="pl-2">
      <span class="title">{{title}}</span>
    </v-col>
    <v-col cols="12" md="4" xs="4" sm="4" class="d-flex flex-row-reverse pr-1" align-self="center">
      <template v-if="!label">
        <v-btn text icon x-small class="mr-1" @click="closeFn">
          <v-icon>mdi-close-thick</v-icon>
        </v-btn>
        <v-btn text icon x-small class="mr-1" @click="upOrDown">
          <v-icon>{{ getIcon() }}</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-chip class="mr-2" small :color="labelColor" label>
          {{labelText}}
        </v-chip>
      </template>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "card-header",
    props: {
      title: String,
      label: {
        type: Boolean,
        default: false
      },
      labelText: String,
      labelColor: {
        type:String,
        default:"primary"
      }
    },
    data() {
      return {
        isUp:true
      }
    },
    methods:{
        getIcon(){
            if(this.isUp)
              return 'mdi-chevron-double-up';
            return 'mdi-chevron-double-down';
        },
        upOrDown(){
            this.isUp = !this.isUp;
            this.$emit('preMethod');
        },
        closeFn(){
            this.$emit('preCloseMethod');
        },
    }
  }
</script>

<style scoped="scoped">
  .card-line {
    border-bottom: 1px solid #303030;
  }
</style>



// WEBPACK FOOTER //
// src/components/card/CardHeader.vue